export function shortStoreName(fullName: string): string {
  const match = /（(.+?)）/.exec(fullName);
  return match ? match[1] : fullName;
}
